import {
  THREAD_PANEL_SHRINK_THRESHOLD,
  THREAD_PANEL_SIZE,
} from '@src/features/shared/community/constants/chatBoxThreadPanelResize';
import useIsMobile from '@src/hooks/useIsMobile';
import { COMPANY_URL } from '@src/routes/company';
import Button from '@src/ui/elements/button/Button';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

type LoginPromptProps = {
  chatBoxWidth?: number;
  isDisplayed?: boolean;
};

const LoginPrompt = ({ chatBoxWidth, isDisplayed = false }: LoginPromptProps) => {
  const navigate = useNavigate();
  const [buttonWidth, setButtonWidth] = useState(300);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!chatBoxWidth || isMobile) {
      return;
    }

    if (chatBoxWidth < THREAD_PANEL_SHRINK_THRESHOLD.small) {
      setButtonWidth(THREAD_PANEL_SIZE.small);
    } else if (chatBoxWidth < THREAD_PANEL_SHRINK_THRESHOLD.medium) {
      setButtonWidth(THREAD_PANEL_SIZE.medium);
    } else {
      setButtonWidth(THREAD_PANEL_SIZE.large);
    }
  }, [chatBoxWidth, isMobile]);

  return (
    isDisplayed && (
      <div
        className='absolute inset-0 z-[9999] grid place-content-center
             bg-white/85 lg:fixed lg:bottom-[15px] lg:left-1/2 lg:top-auto
             lg:w-[calc(100%-30px)] lg:-translate-x-1/2 lg:rounded-[4px] lg:border
              lg:border-gray-200 lg:py-6 md:py-4'
      >
        <div className='flex h-40 items-center justify-center gap-4 p-4 lg:flex-wrap'>
          <div className='flex flex-col items-center gap-1 lg:gap-2 md:w-full'>
            <p
              style={{ width: buttonWidth }}
              className='line-clamp-1 text-center text-xs font-semibold'
            >
              メッセージを投稿するにはログインが必要です。
            </p>
            <div
              style={{ width: buttonWidth }}
              className='md:w-full md:max-w-[280px]'
            >
              <Button
                size='s'
                fullRounded
                fullWidth
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(COMPANY_URL.REGISTRATION);
                }}
              >
                新規会員登録
              </Button>
            </div>
          </div>

          <div className='flex flex-col items-center gap-1 md:w-full md:gap-2'>
            <p className='line-clamp-1 text-center text-xs'>すでにアカウントをお持ちの方</p>
            <div
              style={{ width: buttonWidth }}
              className='md:w-full md:max-w-[280px]'
            >
              <Button
                size='s'
                fullRounded
                fullWidth
                outline
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(COMPANY_URL.LOGIN);
                }}
              >
                ログイン
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default LoginPrompt;
